module.exports = __webpack_public_path__ + "static/img/1-1.f2007c3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/1-1.png
// module id = 9aKa
// module chunks = 0